import { render, staticRenderFns } from "./ListchatLayout.vue?vue&type=template&id=34bf4a5f&scoped=true&lang=html&"
import script from "./ListchatLayout.vue?vue&type=script&lang=js&"
export * from "./ListchatLayout.vue?vue&type=script&lang=js&"
import style0 from "./ListchatLayout.vue?vue&type=style&index=0&id=34bf4a5f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf4a5f",
  null
  
)

export default component.exports